var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.haveUser
    ? _c(
        "div",
        [
          _vm.onDefaultProfileView
            ? [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "container-fluid" },
                  [
                    _vm.$vlastMode && _vm.$user.id === _vm.user.id
                      ? _c("profile-vlast-privacy-policy")
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$userIsAdmin &&
                    _vm.userIsTalent &&
                    _vm.user.profile &&
                    _vm.user.profile.onboarding_video_link
                      ? _c("profile-onboarding-video", {
                          attrs: { user: _vm.user },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.userIsTalent &&
                    !_vm.$vlastMode &&
                    _vm.user.status === "active" &&
                    _vm.user.profile &&
                    _vm.user.profile.visibility === "public"
                      ? _c("profile-social-sharing")
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.userIsMasterManager && _vm.$userIsAdmin
                      ? _c("profile-manager-counts")
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.userIsTalent ? _c("profile-talent-section") : _vm._e(),
                    _vm._v(" "),
                    _vm.showAccountDetails
                      ? _c("profile-account-details")
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showAccountDetails && _vm.user.custom_fields
                      ? _c("profile-additional-details")
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showPaymentDetails
                      ? _c("profile-payment-details-section")
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.$userIsIntern &&
                    this.$user.role !== "sales" &&
                    _vm.userIsActive &&
                    !this.userIsRestrictedAdminAndPermissionIsEnabled
                      ? _c("profile-change-password")
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.user.id == _vm.$user.id
                      ? _c("profile-card-details-section")
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$talentContractsModuleEnabled &&
                    _vm.userIsActive &&
                    _vm.user.contracts &&
                    _vm.user.contracts.length
                      ? _c("profile-contracts")
                      : _vm._e(),
                    _vm._v(" "),
                    !(_vm.userIsClient && _vm.clientName === "GSE")
                      ? _c("profile-date-time-preferences")
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.userIsTalent && _vm.userIsActive
                      ? _c(
                          "ul",
                          { staticClass: "item-detail item-detail-simple" },
                          [
                            _c(
                              "li",
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: {
                                        name: `${_vm.$route.name}.images`,
                                        params: { id: _vm.user.id },
                                      },
                                    },
                                  },
                                  [
                                    _c("div", { staticClass: "row" }, [
                                      _c("div", { staticClass: "col-xs-8" }, [
                                        _c("h3", { staticClass: "has-sub" }, [
                                          _vm._v("Profile Image"),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", { staticClass: "sub-text" }, [
                                          _vm._v(
                                            "Upload a profile image to be used across the site"
                                          ),
                                        ]),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "col-xs-4" }, [
                                        _c(
                                          "div",
                                          { staticClass: "actions pull-right" },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "btn btn-info" },
                                              [
                                                _c("i", {
                                                  staticClass: "fa fa-pencil",
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    (_vm.$userIsAdmin || _vm.$userIsIntern) &&
                    _vm.userIsClientAndActiveClientModuleEnabled
                      ? _c("profile-market-segment")
                      : _vm._e(),
                    _vm._v(" "),
                    (_vm.$userIsAdmin || _vm.$userIsIntern) &&
                    _vm.userIsTalent &&
                    !_vm.$vlastMode
                      ? _c("profile-talent-visibility-options")
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.$vlastMode && _vm.$userIsAdmin && _vm.userIsTalent
                      ? _c("profile-talent-scores")
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.userIsTalent &&
                    (_vm.$userIsAdmin || _vm.$userIsMasterManager) &&
                    _vm.$managerModuleEnabled
                      ? _c("profile-talent-management-options")
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.userIsMasterManager &&
                    _vm.$userIsAdmin &&
                    _vm.$paymentsModuleEnabled
                      ? _c("profile-manager-management-options")
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showAccountDetails && !_vm.$userIsAdmin
                      ? _c("profile-club-form")
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.userIsMasterManager
                      ? _c("profile-manager-staff")
                      : _vm._e(),
                    _vm._v(" "),
                    ((_vm.$userIsAdmin ||
                      _vm.$userIsIntern ||
                      _vm.$userIsManager) &&
                      _vm.userIsTalent) ||
                    _vm.$userIsTalent
                      ? _c("profile-talent-bookings", {
                          attrs: { talent: _vm.user },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.user.id &&
                    _vm.userIsTalent &&
                    _vm.$userIsAdmin &&
                    !_vm.$vlastMode
                      ? _c("profile-notes", { attrs: { talent: _vm.user } })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.userIsActive || _vm.$vlastMode
                      ? _c("profile-account-actions")
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.$vlastMode ? _c("profile-privacy-data") : _vm._e(),
                  ],
                  1
                ),
              ]
            : [_c("router-view")],
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "dashboard-page-title" }, [
      _c("div", { staticClass: "container-fluid" }, [
        _c("h1", [_vm._v("Profile")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }